import { DateTime } from "luxon";
export class Enrollment {
    constructor(input) {
        this.input = input;
        this.oldValue = input.value;
        this.error = input.dataset.error;
        this.format = input.dataset.luxonFormat;
        if (this.format === undefined) {
            throw new Error("data parameter luxon-format required in date field");
        }
    }
    static create(form) {
        const input = form.querySelector("#enrollment_deadline");
        if (input === null) {
            return null;
        }
        return new Enrollment(input);
    }
    validate() {
        if (this.oldValue === this.input.value && this.input.value !== "") {
            return null;
        }
        const date = DateTime.fromFormat(this.input.value, this.format);
        if (date < DateTime.now()) {
            return this.error;
        }
        return null;
    }
}
